"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockTTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "INITIAL_AMOUNT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "reduceAmount",
                type: "uint256",
            },
        ],
        name: "_reduceReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
        ],
        name: "setAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "functionName",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "setErrorCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalReserves",
                type: "uint256",
            },
        ],
        name: "setTotalReserves",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "underlying",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class MockTTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockTTokenFactory = MockTTokenFactory;
MockTTokenFactory.bytecode = _bytecode;
MockTTokenFactory.abi = _abi;
//# sourceMappingURL=MockTTokenFactory.js.map